module.exports = __webpack_public_path__ + "static/media/vanjie.2e719b76.png";